import { BehaviorSubject } from "rxjs";
import PermissionResource from 'api/resources/permission';

class PermissionService {
  static instance: PermissionService;

  private permissionsList$: BehaviorSubject<any[]>;

  private constructor() {
    this.permissionsList$ = new BehaviorSubject<any>([]);
  }

  static getInstance(): PermissionService {
    if (!PermissionService.instance) PermissionService.instance = new PermissionService();
    return PermissionService.instance;
  }

  getPermissionsList = () => this.permissionsList$;

  fetch (queryParams: any = {}) {
    return new Promise((resolve, reject) => {
      PermissionResource.fetch(queryParams || {})
        .then((response) => {
          // console.log('permissionsList', response);
          this.permissionsList$.next(response);

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
    });
  }
}

export default PermissionService;
